import { Heading, HStack, VStack } from '@chakra-ui/react'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { REPOSITORY } from '../../../api/repository/Repository'
import ButtonSelector from '../../../components/ButtonSelector/ButtonSelector'
import Table from '../../../components/Table/Table'
import Toast from '../../../components/Toast/Toast'
import { colors } from '../../../utils/theme/styles'
const costCentersColumns = [
  {
    id: 'info',
    Header: 'Detalle',
    type: 'clickeable',
    keyValue: 'sCentroCosto',
  },
  {
    id: 'NombreCetroCosto',
    Header: 'Centro de costo',
  },
  {
    id: 'NombreEmpresa',
    Header: 'Empresa',
  },
  {
    id: 'bFacturacionIndependiente',
    Header: 'Factura independiente',
    type: 'boolean',
  },
]
export default function CostCenters() {
  const [costCentersData, setCostCentersData] = useState([])
  const navigate = useNavigate()

  const goToCreateIndividual = () => {
    navigate('new-cost-center')
  }
  const goToCreateMassive = () => {
    navigate('massive-cost-center')
  }

  const goToCostCenterDetail = (value) => {
    navigate(`costcenter/${value}`)
  }

  const getData = useCallback(async () => {
    await REPOSITORY.wsEmpresa.company
      .getCostCenters()
      .then((response) => {
        setCostCentersData(response.data)
      })
      .catch((error) => {
        setCostCentersData([])
        console.error(error)
      })
  }, [])

  useEffect(() => {
    getData()
    return () => {
      setCostCentersData([])
    }
  }, [])

  return (
    <VStack alignItems="flex-start" spacing="24px">
      <Table
        data={costCentersData}
        columns={costCentersColumns}
        onEmployeeClick={goToCostCenterDetail}
      />
      <Heading variant="h5">Acciones disponibles</Heading>
      <HStack h="56px" w="60%">
        <Toast variant="gray" as="button" onClick={goToCreateIndividual}>
          <ButtonSelector
            icon={faBuilding}
            defaultTextColor={colors.gray[800]}
            label={'Nuevo centro de costo'}
          />
        </Toast>
        <Toast variant="gray" onClick={goToCreateMassive} as="button">
          <ButtonSelector
            icon={faBuilding}
            defaultTextColor={colors.gray[800]}
            label={'Carga masiva centro de costo'}
          />
        </Toast>
      </HStack>
    </VStack>
  )
}
